import { z } from 'zod';

export const escolaInfoResponseSchema = z.object({
  nomeEscola: z.string(),
  cidade: z.string().nullish(),
  uf: z.string().nullish(),
  perfil: z.string().nullish(),
  qtdAlunos: z.number().nullish(),
  qtdTurmas: z.number().nullish(),
  progressoMeta: z.number().nullish(),
  pontosParaMeta: z.number().nullish(),
  mediaRed1000: z.number().nullish(),
  mediaEnem: z.number().nullish(),
  metaEscola: z.number().nullish(),
});

export type EscolaInfoResponse = z.infer<typeof escolaInfoResponseSchema>;
